// Project templates for Flowise

export const templates = {
  blank: {
    name: 'Blank Project',
    description: 'Start with an empty canvas',
    nodes: [],
    connections: []
  },

  simpleFlow: {
    name: 'Simple Flow',
    description: 'Basic Start → Process → End flow',
    nodes: [
      { id: 1, x: 400, y: 80, text: 'Start', type: 'rounded', color: '#10b981', width: 120, height: 50 },
      { id: 2, x: 400, y: 200, text: 'Process', type: 'rectangle', color: '#3b82f6', width: 140, height: 60 },
      { id: 3, x: 400, y: 340, text: 'End', type: 'rounded', color: '#ef4444', width: 120, height: 50 }
    ],
    connections: [
      { id: 1, from: 1, to: 2, label: '', style: 'solid' },
      { id: 2, from: 2, to: 3, label: '', style: 'solid' }
    ]
  },

  decisionTree: {
    name: 'Decision Tree',
    description: 'Flow with Yes/No branching',
    nodes: [
      { id: 1, x: 400, y: 60, text: 'Start', type: 'rounded', color: '#10b981', width: 120, height: 50 },
      { id: 2, x: 400, y: 180, text: 'Is condition\ntrue?', type: 'diamond', color: '#f59e0b', width: 140, height: 100 },
      { id: 3, x: 200, y: 340, text: 'Yes Action', type: 'rectangle', color: '#3b82f6', width: 140, height: 60 },
      { id: 4, x: 600, y: 340, text: 'No Action', type: 'rectangle', color: '#3b82f6', width: 140, height: 60 },
      { id: 5, x: 400, y: 480, text: 'End', type: 'rounded', color: '#ef4444', width: 120, height: 50 }
    ],
    connections: [
      { id: 1, from: 1, to: 2, label: '', style: 'solid' },
      { id: 2, from: 2, to: 3, label: 'Yes', style: 'solid' },
      { id: 3, from: 2, to: 4, label: 'No', style: 'solid' },
      { id: 4, from: 3, to: 5, label: '', style: 'solid' },
      { id: 5, from: 4, to: 5, label: '', style: 'solid' }
    ]
  },

  userRegistration: {
    name: 'User Registration',
    description: 'Sign up flow example',
    nodes: [
      { id: 1, x: 400, y: 40, text: 'Start', type: 'rounded', color: '#10b981', width: 120, height: 50 },
      { id: 2, x: 400, y: 140, text: 'Enter Email', type: 'parallelogram', color: '#8b5cf6', width: 150, height: 60 },
      { id: 3, x: 400, y: 250, text: 'Email Valid?', type: 'diamond', color: '#f59e0b', width: 130, height: 90 },
      { id: 4, x: 200, y: 380, text: 'Show Error', type: 'rectangle', color: '#ef4444', width: 130, height: 50 },
      { id: 5, x: 500, y: 380, text: 'Enter Password', type: 'parallelogram', color: '#8b5cf6', width: 160, height: 60 },
      { id: 6, x: 500, y: 490, text: 'Create Account', type: 'rectangle', color: '#3b82f6', width: 150, height: 60 },
      { id: 7, x: 500, y: 600, text: 'Send Welcome\nEmail', type: 'rectangle', color: '#3b82f6', width: 150, height: 60 },
      { id: 8, x: 500, y: 710, text: 'Done', type: 'rounded', color: '#10b981', width: 120, height: 50 }
    ],
    connections: [
      { id: 1, from: 1, to: 2, label: '', style: 'solid' },
      { id: 2, from: 2, to: 3, label: '', style: 'solid' },
      { id: 3, from: 3, to: 4, label: 'No', style: 'solid' },
      { id: 4, from: 3, to: 5, label: 'Yes', style: 'solid' },
      { id: 5, from: 4, to: 2, label: 'Retry', style: 'solid' },
      { id: 6, from: 5, to: 6, label: '', style: 'solid' },
      { id: 7, from: 6, to: 7, label: '', style: 'solid' },
      { id: 8, from: 7, to: 8, label: '', style: 'solid' }
    ]
  },

  bugFixWorkflow: {
    name: 'Bug Fix Workflow',
    description: 'Report → Triage → Fix → Test → Deploy',
    nodes: [
      { id: 1, x: 400, y: 40, text: 'Bug Reported', type: 'rounded', color: '#ef4444', width: 140, height: 50 },
      { id: 2, x: 400, y: 140, text: 'Triage', type: 'rectangle', color: '#f59e0b', width: 130, height: 60 },
      { id: 3, x: 400, y: 250, text: 'Priority?', type: 'diamond', color: '#f59e0b', width: 120, height: 90 },
      { id: 4, x: 200, y: 380, text: 'Add to\nBacklog', type: 'rectangle', color: '#6b7280', width: 130, height: 60 },
      { id: 5, x: 500, y: 380, text: 'Assign\nDeveloper', type: 'rectangle', color: '#3b82f6', width: 140, height: 60 },
      { id: 6, x: 500, y: 490, text: 'Fix Bug', type: 'rectangle', color: '#3b82f6', width: 130, height: 60 },
      { id: 7, x: 500, y: 600, text: 'Code Review', type: 'rectangle', color: '#8b5cf6', width: 140, height: 60 },
      { id: 8, x: 500, y: 710, text: 'Run Tests', type: 'rectangle', color: '#10b981', width: 130, height: 60 },
      { id: 9, x: 500, y: 820, text: 'Deploy', type: 'rectangle', color: '#10b981', width: 130, height: 60 },
      { id: 10, x: 500, y: 920, text: 'Resolved', type: 'rounded', color: '#10b981', width: 130, height: 50 }
    ],
    connections: [
      { id: 1, from: 1, to: 2, label: '', style: 'solid' },
      { id: 2, from: 2, to: 3, label: '', style: 'solid' },
      { id: 3, from: 3, to: 4, label: 'Low', style: 'solid' },
      { id: 4, from: 3, to: 5, label: 'High', style: 'solid' },
      { id: 5, from: 5, to: 6, label: '', style: 'solid' },
      { id: 6, from: 6, to: 7, label: '', style: 'solid' },
      { id: 7, from: 7, to: 8, label: '', style: 'solid' },
      { id: 8, from: 8, to: 9, label: 'Pass', style: 'solid' },
      { id: 9, from: 9, to: 10, label: '', style: 'solid' }
    ]
  },

  approvalProcess: {
    name: 'Approval Process',
    description: 'Request → Review → Approve/Reject',
    nodes: [
      { id: 1, x: 400, y: 40, text: 'Submit\nRequest', type: 'rounded', color: '#3b82f6', width: 130, height: 60 },
      { id: 2, x: 400, y: 160, text: 'Manager\nReview', type: 'rectangle', color: '#8b5cf6', width: 140, height: 60 },
      { id: 3, x: 400, y: 280, text: 'Approved?', type: 'diamond', color: '#f59e0b', width: 130, height: 90 },
      { id: 4, x: 200, y: 420, text: 'Request\nChanges', type: 'rectangle', color: '#f59e0b', width: 140, height: 60 },
      { id: 5, x: 550, y: 420, text: 'Process\nRequest', type: 'rectangle', color: '#10b981', width: 140, height: 60 },
      { id: 6, x: 200, y: 540, text: 'Update &\nResubmit', type: 'rectangle', color: '#3b82f6', width: 140, height: 60 },
      { id: 7, x: 550, y: 540, text: 'Notify\nRequester', type: 'rectangle', color: '#3b82f6', width: 140, height: 60 },
      { id: 8, x: 550, y: 660, text: 'Complete', type: 'rounded', color: '#10b981', width: 120, height: 50 }
    ],
    connections: [
      { id: 1, from: 1, to: 2, label: '', style: 'solid' },
      { id: 2, from: 2, to: 3, label: '', style: 'solid' },
      { id: 3, from: 3, to: 4, label: 'No', style: 'solid' },
      { id: 4, from: 3, to: 5, label: 'Yes', style: 'solid' },
      { id: 5, from: 4, to: 6, label: '', style: 'solid' },
      { id: 6, from: 6, to: 2, label: '', style: 'solid' },
      { id: 7, from: 5, to: 7, label: '', style: 'solid' },
      { id: 8, from: 7, to: 8, label: '', style: 'solid' }
    ]
  }
};

export const getTemplate = (templateKey) => {
  const template = templates[templateKey];
  if (!template) return templates.blank;

  return {
    nodes: JSON.parse(JSON.stringify(template.nodes)),
    connections: JSON.parse(JSON.stringify(template.connections))
  };
};

export const templateList = [
  { key: 'blank', ...templates.blank },
  { key: 'simpleFlow', ...templates.simpleFlow },
  { key: 'decisionTree', ...templates.decisionTree },
  { key: 'userRegistration', ...templates.userRegistration },
  { key: 'bugFixWorkflow', ...templates.bugFixWorkflow },
  { key: 'approvalProcess', ...templates.approvalProcess }
];
